import { z } from 'zod'

export const schema = z.object({
  reviews: z.array(
    z.object({
      id: z.string(),
      title: z.string(),
      description: z.string(),
      points: z.number().int(),
      cottage: z.object({
        id: z.string(),
        name: z.string(),
        slug: z.string(),
      }),
      traveler: z.object({
        id: z.string(),
        name: z.string(),
        media: z.object({
          url: z.string(),
        }),
      }),
    }),
  ),
  summaryDTO: z.object({
    averageReviewScore: z.number(),
    bestScore: z.number().int(),
    countScore: z.number().int(),
  }),
  googleData: z.object({
    rating: z.number().nullable(),
    reviewsNumber: z.number().int().nullable(),
    reviews: z.array(
      z.object({
        authorName: z.string(),
        profilePhotoUrl: z.string(),
        rating: z.number(),
        text: z.string(),
        createdAt: z.string(),
      }),
    ),
  }),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  id: z.string(),
  limit: z.number().int(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
